import styles from './index.module.scss';
import Plus from './plus';
import Close from './close';

interface TabCompProps {
    title: string;
    contentTitle: string;
    contentDesc: string;
    className?: string;
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
}

const TabComp: React.FC<TabCompProps> = ({ title, contentTitle, contentDesc, className, isOpen, onOpen, onClose }) => {
    const handleOpen = () => {
        onOpen();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <div className={styles.TabComp + ' ' + className}>
            <div className="box">
                <div className="title-box" onClick={handleOpen}>
                    <div className="title">{title}</div>
                    <Plus />
                </div>

                <div className={`content ${isOpen ? 'open' : ''}`}>
                    <div className="title">{contentTitle}</div>
                    <div className="desc">{contentDesc}</div>

                    <div className="close-btn">
                        <Close onClick={handleClose} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TabComp;
